import { Role } from 'types/api';

export const roleDisplayName = (role: Role | undefined): string | undefined => {
  if (role) {
    return role?.replace('Organization', '');
  } else {
    return undefined;
  }
};
